import React from "react";
import { useAuth } from "../context/AuthContext";
import { useTranslation } from "react-i18next";
import LanguageSwitcher from "./LanguageSwitcher";
import { useSidebar } from "../app/App";

export default function Topbar() {
  const { user, logout } = useAuth();
  const { t } = useTranslation();
  const { sidebarOpen, toggleSidebar } = useSidebar();

  return (
    <div className="w-full h-16 md:h-16 border-b border-glass-10 bg-night-950/95 backdrop-blur-xl px-4 md:px-6 flex items-center justify-between sticky top-0 z-50">
      <div className="flex items-center gap-2 md:gap-4">
        {/* Hamburger menu button - only visible on mobile/tablet */}
        <button
          onClick={toggleSidebar}
          className="lg:hidden p-2 rounded-lg bg-glass-5 hover:bg-glass-10 border border-glass-10 transition-colors"
          aria-label={sidebarOpen ? "Close sidebar" : "Open sidebar"}
        >
          {sidebarOpen ? (
            <svg className="w-5 h-5 text-ink-200" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          ) : (
            <svg className="w-5 h-5 text-ink-200" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
            </svg>
          )}
        </button>

        <h1 className="font-display text-xl md:text-2xl font-bold text-white">
          <span className="text-emerald-400">i</span>GROWth
        </h1>
        <div className="hidden md:block h-8 w-px bg-glass-10"></div>
        <span className="hidden md:block text-sm text-ink-400 font-medium">{t("app.subtitle")}</span>
      </div>
      <div className="flex items-center gap-2 md:gap-6">
        <LanguageSwitcher />
        {user && (
          <>
            {/* User info - hidden on small screens, shown on md+ */}
            <div className="hidden md:flex items-center gap-3 px-4 py-2 bg-glass-5 rounded-lg border border-glass-10">
              <div className="w-2 h-2 rounded-full bg-accent-400 animate-pulse"></div>
              <span className="text-sm text-ink-200 font-medium">{user.email}</span>
            </div>
            {/* Logout button */}
            <button
              onClick={logout}
              className="text-sm px-3 md:px-5 py-2 md:py-2.5 rounded-lg bg-glass-8 hover:bg-glass-15 border border-glass-10 hover:border-brand-500 text-ink-100 font-medium transition-all duration-200 hover:scale-105"
            >
              <span className="hidden sm:inline">{t("common.logout")}</span>
              <svg className="sm:hidden w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
              </svg>
            </button>
          </>
        )}
      </div>
    </div>
  );
}
